<template>
    <div class="decrees-modal-wrapper">
        <div class="overlay" v-if="show" @click="onCloseCallback"></div>
        <div
            v-if="show"
            class="modal decrees-modal"
            :class="{['game-in-drafting']: gameInDrafting}"
        >
            <div class="modal-content">
                <div class="decree-cards-wrapper">
                    <decree-card :decree="decree" v-for="decree in decrees" :key="`decree-${decree.id}`" />
                </div>
            </div>
			<span class="dismiss-btn" @click="onCloseCallback">
            	<fa-icon class="icon" icon="times" />
			</span>
        </div>
    </div>
</template>

<script>
import find from 'lodash.find';

export default {
    props: ['decrees', 'show', 'onCloseCallback', 'gameInDrafting'],
    name: 'DecreesModal',
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .modal {

        &.decrees-modal {
            background: $cream;
            height: 100%;
            max-width: none;
            padding: 40px 20px;
            top: 0;
            transform: translateX(-50%);
            width: auto;

            .modal-content {
                display: flex;
                flex-direction: column;
                height: 100%;
                max-width: none;
                overflow: auto;

                .decree-cards-wrapper {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .decree-card {
                    align-self: center;
                    margin-bottom: 20px;
                }
            }

            .dismiss-btn {
                cursor: pointer;
                font-size: 1.6em;
                position: absolute;
                right: 15px;
                top: 10px;
            }
        }
    }

    @media only screen and (min-width: $screen-xs) {

        .modal {

            &.decrees-modal {
                height: auto;
                padding: 20px 45px;
                top: 50%;
                transform: translate(-50%, -50%);

                .modal-content {
                    flex-direction: row;

                    .decree-cards-wrapper {
                        flex-direction: row;
                    }

                    .decree-card {
                        margin-bottom: 0;
                        margin-right: 50px;

                        &:last-of-type {
                            margin-right: 0;
                        }
                    }
                }

                &.game-in-drafting {

                    .modal-content {

                        .decree-card {
                            margin-right: 35px;
                            transform: scale(1);

                            &:last-of-type {
                                margin-right: 0;
                            }
                        }
                    }
                }
            }
        }
    }

</style>
